













import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Rating extends Vue {
  @Prop() private rating!: number;

  emptyOrFullStar(idx: number): string[] {
    return idx + 1 <= this.rating ? ["fas", "star"] : ["far", "star"];
  }

  get customVuexStyles() {
    return {
      "--font-main": this.$store.state.globalCss.font.fontName,
      "--rating-color": this.$store.state.globalCss.colors.rating.color,
      "--rating-icon-size": this.$store.state.globalCss.colors.rating.iconSize
    };
  }

  get isRatingEnabled() {
    return this.$store.state.globalConfig.ratingsEnabled;
  }
}
